/**
 * The single row-count wording helper for the whole workspace — the Query
 * Editor status bar and results grid, the Table Explorer, notebook cells, the
 * FK preview and the start page's query history all format through here, so
 * one query's row count reads identically wherever it is stated. (An identical
 * copy previously lived in `start-page/utils/timestampFormatting.ts`; it was
 * folded into this one rather than left to drift.)
 *
 * Formats a row count for display with correct singular/plural wording and
 * thousands separators, e.g. `formatRowCount(1)` → `"1 row"`,
 * `formatRowCount(3)` → `"3 rows"`.
 *
 * Zero reads as **"0 rows"**, not "No rows" — this matches every other
 * row-count surface already in the app (the Table Explorer pagination strip,
 * the grid loading indicator) and the general English convention of
 * treating zero as plural ("0 items", "0 results"). Keeping zero numeric
 * also means the row-count widget never switches from a number to a word,
 * so a user scanning the status bar for a digit always finds one.
 */
export function formatRowCount(count: number): string {
  const formatted = count.toLocaleString();
  return count === 1 ? `${formatted} row` : `${formatted} rows`;
}
